import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const DashboardBrief = ({ userId, userName }) => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const [countOfResume, setCountOfResumes] = useState(null);
    const [countOfCompanies, setCountOfCompanies] = useState(null);
    const [countOfAppliedCompanies, setCountOfAppliedCompanies] = useState(null);
    const [countOfshortlistedApplications, setCountOfshortlistedApplications] = useState(null);
    const [resumeViewCount, setResumeViewCount] = useState(null);
    // const [userName, setUserName] = useState('');
    // const [userId, setUserId] = useState(null);


    // useEffect(() => {
    //     // Get the userName and userId from location.state if available, otherwise from localStorage
    //     const storedUser = JSON.parse(localStorage.getItem('user'));  // Assuming 'user' is stored in localStorage

    //     const userNameFromLocation = location.state?.userName || storedUser?.userName || '';
    //     const userIdFromLocation = location.state?.userId || storedUser?.userId || null;

    //     // console.log(userIdFromLocation)
    //     setUserName(userNameFromLocation);
    //     setUserId(userIdFromLocation);
    // }, [location]);

    // useEffect(() => {
    //     if (!userName && userId) {
    //         fetchUserData(userId);
    //     }
    // }, [userId, userName]);
    // useEffect(() => {
    //     const storedUserName = localStorage.getItem(`userName_${userId}`);
    //     if (storedUserName) {
    //         setUserName(storedUserName);
    //     }
    // }, [userId]);

    // const fetchUserData = async (userId) => {
    //     try {
    //         const response = await axios.get(`${BASE_API_URL}/getUserName`, {
    //             params: {
    //                 userId: userId
    //             }
    //         });
    //         console.log(response.data);
    //         setUserName(response.data.userName);
    //         localStorage.setItem(`userName_${userId}`, response.data.userName); // Store userName with user-specific key
    //         setUserData(response.data);
    //     } catch (error) {
    //         setUserData(null);
    //     }
    // };



    // console.log(userId)
    useEffect(() => {
       
        const fetchData = async (userId) => {
            // Get the userName and userId from location.state if available, otherwise from localStorage
            // const storedUser = JSON.parse(localStorage.getItem('user'));
            // const userIdFromLocation = location.state?.userId || storedUser?.userId || null;

            // if (userIdFromLocation) {
            //     setUserId(userIdFromLocation);
            // } else {
            //     console.error('No userId found!');
            //     return;
            // }

            try {
                const countCompanies = await axios.get(`${BASE_API_URL}/countValidatedCompanies`, {
                    params: {
                        userId: userId  // userIdFromLocation
                    }
                });
                // console.log(countCompanies.data);
                setCountOfCompanies(countCompanies.data);

                const countOfAppliedCompanies = await axios.get(`${BASE_API_URL}/countAppliedCompanies`, {
                    params: {
                        userId: userId // userIdFromLocation
                    }
                });
                // console.log(countOfAppliedCompanies.data);
                setCountOfAppliedCompanies(countOfAppliedCompanies.data);

                const countResumes = await axios.get(`${BASE_API_URL}/getCountOfResumes`, {
                    params: {
                        userId: userId // userIdFromLocation
                    }
                });
                // console.log(countResumes.data);
                setCountOfResumes(countResumes.data);
                const shortlist = await axios.get(`${BASE_API_URL}/getCountOfTotalShortlistedApplication`, {
                    params: {
                        userId: userId // userIdFromLocation
                    }
                });
                // console.log(shortlist.data);
                setCountOfshortlistedApplications(shortlist.data);

                const resumecount = await axios.get(`${BASE_API_URL}/resume-view-count`, {
                    params: {
                        userId: userId // userIdFromLocation
                    }
                });
                setResumeViewCount(resumecount.data ?? 0);
            } catch (error) {
                console.error('Error fetching Data:', error);
                setCountOfCompanies(null);
            }
        };

        if (userId)
            fetchData(userId);
    }, [userId]);

    const DATA = [
        { title: countOfAppliedCompanies, subtitle: "Applied Companies", link: "/candidate-dashboard/companies", state: { userName, userId, appliedCompany: true } },
        { title: countOfResume, subtitle: "Resumes", link: "/candidate-dashboard/resume" },
        { title: resumeViewCount, subtitle: "Resume Views" },
        { title: countOfshortlistedApplications, subtitle: "Shortlist", link: '/candidate-dashboard/my-application', state: { userName, userId, applicationStatus: true } },
    ];
    return (
        <Col md={12} style={{ paddingLeft: '15px', paddingRight: '15px' }}>
            <Row>
                {DATA.map((item, index) => (
                    <Col lg={3} sm={6} key={index}>
                        <Card
                            className="card card-icon-bg card-icon-bg-primary o-hidden mb-4"
                            style={{ height: '100px', paddingLeft: '10px' }}
                        >
                            <Card.Body>
                                {/* <FontAwesomeIcon icon={item.icon} className="me-2 text-primary mb-0 text-24 fw-semibold" /> */}
                                <div className="content gap-1">
                                    {item.link ? (
                                        <Link
                                            to={item.link}
                                            state={item.state ? item.state : { userName, userId }}
                                            className="nav-link"
                                        >
                                            <p className="text-muted mb-0 text-capitalize title-responsive" style={{ width: '150px' }}>
                                                {item.subtitle}
                                            </p>
                                            <p className="lead text-primary text-24 mb-0 text-capitalize">
                                                {item.title}
                                            </p>
                                        </Link>
                                    ) : (
                                        <div>
                                            <p className="text-muted mb-0 text-capitalize subtitle-responsive" style={{ width: '150px' }}>
                                                {item.subtitle}
                                            </p>
                                            <p className="lead text-primary text-24 mb-0 text-capitalize">
                                                {item.title}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Col>

    )
}

export default DashboardBrief
